import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from './firebase';

import { LoginPage } from './pages/LoginPage';
import { Dashboard } from './pages/Dashboard';
import { NewPhotos } from './pages/NewPhotos';
import { AlertPhotos } from './pages/AlertPhotos';
import { LabeledPhotos } from './pages/LabeledPhotos';
import { UploadPhotoPage } from './pages/UploadPhotoPage';
import { CountersPage } from './pages/CountersPage';
import ExportDatasetPage from './pages/ExportDataset';

import NonAuthLayout from './components/NonAuthLayout';
import Layout from './components/Layout';
import AuthWatcher from './components/AuthWatcher';            // NEW

const AppRoute = ({ children }) => {
  if (!localStorage.getItem('authUser')) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

function App() {
  return (
    <Router>
      <AuthWatcher />                                          {/* NEW – global session monitor */}
      <Routes>
        {/* Public */}
        <Route
          path="/login"
          element={
            <NonAuthLayout>
              <LoginPage />
            </NonAuthLayout>
          }
        />
        <Route path="/logout" element={<Logout />} />

        {/* Protected */}
        <Route
          path="/dashboard"
          element={
            <AppRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </AppRoute>
          }
        />
        <Route
          path="/new-photos"
          element={
            <AppRoute>
              <Layout>
                <NewPhotos />
              </Layout>
            </AppRoute>
          }
        />
        <Route
          path="/alert-photos"
          element={
            <AppRoute>
              <Layout>
                <AlertPhotos />
              </Layout>
            </AppRoute>
          }
        />
        <Route
          path="/labeled-photos"
          element={
            <AppRoute>
              <Layout>
                <LabeledPhotos />
              </Layout>
            </AppRoute>
          }
        />

        {/* Export Dataset */}
        <Route
          path="/export-dataset"
          element={
            <AppRoute>
              <Layout>
                <ExportDatasetPage />
              </Layout>
            </AppRoute>
          }
        />

        <Route
          path="/upload-photo"
          element={
            <AppRoute>
              <Layout>
                <UploadPhotoPage />
              </Layout>
            </AppRoute>
          }
        />
        <Route
          path="/counters"
          element={
            <AppRoute>
              <Layout>
                <CountersPage />
              </Layout>
            </AppRoute>
          }
        />

        {/* Default fallback */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

// Dummy Logout component
function Logout() {
  useEffect(() => {
    signOut(auth).catch(() => {});
    localStorage.removeItem('idToken');
    localStorage.removeItem('username');
    localStorage.removeItem('authUser');
  }, []);
  return <Navigate to="/login" replace />;
}

export default App;

